import React, { Component } from "react"

import { HeadingInitial, HeadingSecondary, Paragraph, Section } from "elements"

class AboutPage extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>What Makes Us Unique</HeadingInitial>

        <Section>
          <HeadingSecondary>Knowledge</HeadingSecondary>

          <Paragraph>
            Camps and Campers was created by the founders of Campstaff.com,
            summer camp directors and camp parents as a technology-based
            solution to the real challenges of finding camps and campers. (You
            can read more about our history here.)
          </Paragraph>

          <Paragraph>
            The result is the most interactive website for matching campers and
            camps—and, most importantly, simplifying the contact process between
            both.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>Bidirectional</HeadingSecondary>
          <Paragraph>
            Our two-way database connects families searching for summer camps
            and summer camps searching for new camp families. We use the latest
            technology to give both parties a new level of control over their
            respective searches and unprecedented ease of exchanging
            information.
          </Paragraph>
          <Paragraph>
            Both camps and camp families submit detailed information with their
            Camps and Campers registration. This consolidated information saves
            everybody time and effort as they look to fill and find camp
            openings, because both groups have the details needed to pursue only
            fruitful paths.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>Bidirectional</HeadingSecondary>
          <Paragraph>
            Only Camps and Campers features camp recommendations by professional
            camp directors.
          </Paragraph>
          <Paragraph>
            We asked professional camp directors a simple question, “Which camps
            would you recommend to your best friend?” Camp search results are
            listed in the order of these poll results.
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default AboutPage



// WEBPACK FOOTER //
// ./src/scenes/About/pages/about.js